(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /**
     * Update the width of lines under tabs based on their parent container's scrollable width.
     * This is necessary to ensure the line spans the full width of the tab content, whilst also not spanning the full viewport width.
     */
    const updateLines = () => {
      const lines = document.querySelectorAll('[data-details-line]');
      lines.forEach(line => {
        const parent = line.parentElement;
        if (parent)
          line.style.width = `calc(${
            parent.scrollWidth || parent.offsetWidth
          }px - var(--spacing-offset) * 3)`;
      });
    };

    // Initial update and on resize
    updateLines();
    window.addEventListener('resize', updateLines);
  })();

  } catch(e) { console.error(e); }
})();
})();
